import { Injectable } from '@angular/core';

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  name: string;
  type?: string;
}

export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

const MENUITEMS = [
  // {
  //   state: 'dashboard',
  //   name: _tk('site.dashboard'),
  //   type: 'link',
  //   icon: 'dashboard'
  // },
  // {
  //   state: 'calllog',
  //   name: _tk('tab_navigation_menu.call_log'),
  //   type: 'link',
  //   icon: 'history'
  // },
  // {
  //   state: 'enterprise-contacts',
  //   name: _tk('enterprise_contact.title.manage'),
  //   type: 'link',
  //   icon: 'contacts'
  // },
  // {
  //   state: 'phonevoicemailqueue',
  //   name: _tk('menu.voicemail'),
  //   type: 'link',
  //   icon: 'keyboard_voice'
  // }
];

@Injectable()
export class MenuService {

  getAll(): Menu[] {
    return MENUITEMS;
  }

  add(menu): void {
    MENUITEMS.push(menu);
  }
}
